import moment from "moment";
import CustomDataGrid from "../../../components/customDataGrid";
import { DATE_TIME_FORMAT } from "../../../config/const";
import { Box, IconButton, Stack } from "@mui/material";
import { Delete, EditCalendar, Flag } from "@mui/icons-material";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import NullCheck from "../../../components/NullCheck";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useDispatch, useSelector } from "react-redux";
import { ROLES_ID } from "../../../config/roles";
import { currencyFormat } from "../../../config/functions";
import { ST_TYPE_ID } from "../const";
import { setServicesCallDetails } from "store/servicesCallSlice";

const TableData = ({ deleteServicesCall, filterlist, displaySettings, createGoogleCalendar }) => {
  const dispatch = useDispatch()
  const { bt } = useBizTypeTranslation();
  const user = useSelector((state) => state.userSettings?.user);
  const employees = useSelector((state) => state?.employees?.list);

  const columns = [
    {
      field: "hasFlag",
      headerName: bt("FLAG"),
      width: 100,
      hideInExport: true,
      renderCell: (value) => {
        return (
          <Stack height='100%' justifyContent="center" >
            <NullCheck valueForCheck={value?.row?.hasFlag}>
              <Flag color={value?.row?.isOutOfTime ? 'black' : "warning"} />
            </NullCheck>
          </Stack>
        )
      },
    },
    {
      field: "color",
      headerName: bt("COLOR"),
      width: 80,
      hideInExport: true,
      filterable: false,
      renderCell: (value) => {
        return (
          <Stack height='100%' justifyContent="center" >
            <NullCheck valueForCheck={value?.row?.color}>
              <Box sx={{
                width: 50,
                height: 16,
                bgcolor: value?.row?.color,
                borderRadius: "10%",
                border: "1px solid",
              }} />
            </NullCheck>
          </Stack>
        )
      },
    },
    {
      field: "callId",
      headerName: bt("CALL_ID"),
      width: 130,
    },
    {
      field: "name",
      headerName: bt("CONTACT_NAME"),
      width: 150,
      renderCell: (value) => {
        return value?.row.name ? `${value?.row.name}` : "";
      },
    },
    {
      field: "company",
      headerName: bt("COMPANY"),
      width: 150,
      renderCell: (value) => {
        return value?.row?.clienCompany ?? "";
      },
    },
    {
      field: "addr",
      headerName: bt("ADDR"),
      width: 150,
      renderCell: (value) => {
        return value?.row?.addr ?? "";
      },
    },
    {
      field: "tel",
      headerName: bt("TEL"),
      width: 150,
      renderCell: (value) => {
        return value?.row?.tel ?? "";
      },
    },
    {
      field: "contentWithItems",
      headerName: bt("CONTENT_WITH_ITEMS"),
      width: 150,
      filterable: false,
      renderCell: (value) => {
        return value?.row?.contentWithItems ?? "";
      },
    },
    {
      field: "notes",
      headerName: bt("NOTES"),
      width: 200,
      filterable: false,
      renderCell: (value) => {
        return value?.row?.notes ?? "";
      },
    },
    {
      field: "price",
      headerName: bt("PRICE"),
      width: 120,
      renderCell: (value) => {
        return value?.row?.price ? currencyFormat(value?.row?.price) : "";
      },
    },
    {
      field: "providersExpenses",
      headerName: bt("PROVIDERS_EXPENSES"),
      width: 150,
      renderCell: (value) => {
        return value?.row?.providersExpenses ? currencyFormat(value?.row?.providersExpenses) : "";
      },
    },
    {
      field: "clientCallId",
      headerName: bt("CLIENT_CALL_ID"),
      width: 150,
    },
    {
      field: "workDt",
      headerName: bt("WORK_DT"),
      width: 150,
      renderCell: (value) => {
        return value?.row.workDt
          ? moment(value?.row.workDt).format(DATE_TIME_FORMAT)
          : "";
      },
    },
    {
      field: "created",
      headerName: bt("CREATED"),
      width: 150,
      renderCell: (value) => {
        return value?.row.created
          ? moment(value?.row.created).format(DATE_TIME_FORMAT)
          : "";
      },
    },
    {
      field: "associatedEmpName",
      headerName: bt("SELECT_EMPLOYEE"),
      width: 150,
      renderCell: (value) => value?.row.associatedEmpName
    },
    {
      field: "providers",
      headerName: bt("PROVIDERS"),
      width: 150,
      renderCell: (value) => {
        return value?.row?.providers ?? "";
      },
    },
    {
      field: "create_google_calendar",
      headerName: bt("CREATE_GOOGLE_CALENDAR"),
      width: 80,
      hideInExport: true,
      filterable: false,
      renderCell: (value) => {
        return (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              dispatch(createGoogleCalendar(value?.row))
            }}
          >
            <EditCalendar />
          </IconButton>
        );
      },
    },
    // {
    //   field: "delete",
    //   headerName: bt("DELETE"),
    //   flex: 80,
    //   filterable: false,
    //   renderCell: (value) => {
    //     return (
    //       <NullCheck valueForCheck={user?.userRole !== ROLES_ID.EMPLOYEE}>
    //         <IconButton
    //           onClick={(e) => {
    //             e.stopPropagation();
    //             deleteServicesCall(value.id, value?.row?.callId);
    //           }}
    //         >
    //           <Delete />
    //         </IconButton>
    //       </NullCheck>
    //     );
    //   },
    // },
  ]

  return (
    <CustomDataGrid
      defaultSort={[{ field: "workDt", sort: "asc" }]}
      setItem={(call) => dispatch(setServicesCallDetails(call))}
      columnVisibilityModel={displaySettings?.show}
      getRowClassName={(params) => {
        return !params?.row?.isRead
          ? "cold"
          : params?.row?.workDt &&
            params?.row?.stTypeId === ST_TYPE_ID.OPEN &&
            moment(params?.row?.workDt).isBefore(moment(), 'day')
            ? "hot"
            : ""
      }}
      columns={columns}
      list={filterlist?.map((call) => {
        const associatedEmp = employees?.find(emp => emp?.id === call?.employee)
        const isOutOfTime = call?.workDt &&
          call?.stTypeId === ST_TYPE_ID.OPEN &&
          moment(call?.workDt).isBefore(moment(), 'day')
        return {
          ...call,
          id: call?._id,
          color: call?.color,
          callId: call?.callId,
          clientCallId: call?.clientCallId,
          name: call?.name,
          company: call?.clienCompany,
          tel: call?.tel,
          workDt: call?.workDt,
          created: call?.created,
          isOutOfTime: isOutOfTime,
          associatedEmpName: `${associatedEmp?.fn} ${associatedEmp?.ln}`,
          content: call?.content,
          delete: call?.id,
        };
      })}
    />
  );
};
export default TableData;
